//@flow
import React from 'react';
import {Link} from 'react-router';
import ShippingPrice from './ShippingPrice.react';
import {parseStylesFromHelloBarMeta} from '../../Stores/Mktg/mktgStoreClass';
/* This component determines if a user is in the US or not. If
they are in the US, the helloBar will show them one of two things.
If they have no items in their cart, it will say free shipping on
orders over $25. If it's less than $25 worth of items, it will show
how much more they need to order to get to free shipping. If they are in the
collections flow, we show everything using the discount of 50%
*/

import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type CustomerModel from '../../Stores/Customer/customerModel';
import type { HelloBarConfig } from '../../Stores/Mktg/mktgModelInterfaces';

type Props = {
  quoteTotals:QuoteTotalsModel,
  inUS:boolean,
  config:HelloBarConfig,
  newMember:boolean,
  customer:CustomerModel,
};

function _getSubtotal(props:Props):number {
  return props.quoteTotals.getSubtotal() || 0;
}

function _getEmptyCartText(props:Props) {
  const config = props.config || {};
  const styles = parseStylesFromHelloBarMeta(props.config.meta);
  const textStyle = styles.color
    ? {color: styles.color}
    : {};
  const text = config.text ||
    `Free delivery on orders over $${props.quoteTotals.getMinimumFreeShipping().toFixed(2)}`;

  if (config.renderMarkup) {
    return _getLinkFromData(config.link, (
      <div
        className="hello-bar-text"
        style={textStyle}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{__html: text}}
      />
    ));
  }

  return _getLinkFromData(config.link, (
    <div className="hello-bar-text" style={textStyle}>
      {text}
    </div>
  ));
}

function _getLinkFromData(url:?string, children:React$Element<*>):?React$Element<*> {
  if (!url) return children;
  if (url.startsWith('/')) {
    return <Link to={url} className="hello-bar-link">{children}</Link>;
  }
  return <a href={url} className="hello-bar-link">{children}</a>;
}

function _getFreeDeliveryText() {
  return (
    <div className="hello-bar-text sales-goal">
      Your delivery is free!&nbsp;
      <Link to="/cart">View cart</Link>
    </div>
  );
}

function _getHelloBarText(props:Props) {
  if (_getSubtotal(props) === 0 || props.config.text) {
    return _getEmptyCartText(props);
  }
  if (!props.quoteTotals.getAmountToFreeShipping()) {
    return _getFreeDeliveryText();
  }

  return (
    <ShippingPrice
      inUS={props.inUS}
      quoteTotals={props.quoteTotals}
    />
  );
}

export default function HelloBar(props:Props) {
  const styles = parseStylesFromHelloBarMeta(props.config.meta);
  const barStyle = styles.backgroundColor
    ? {backgroundColor: styles.backgroundColor}
    : {};
  return (
    <div className="hello-bar" style={barStyle}>
      <div className="text-4">
        <div className="hello-bar-text-container">
          {_getHelloBarText(props)}
        </div>
      </div>
    </div>
  );
}
